import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../_actions/matchesActions";
import InfiniteScroll from "react-infinite-scroller";
import UserWidgetContainer from "../Matches/UserWidgetContainer";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import getConnectedMembers from "../../_selectors/matchesSelectors/getConnectedMembers";
import getMatchesLastResult from "../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../_utils";
import matchesConstants from "../../_constants/matchesConstants";
import getMyConnectedMembersCount from "../../_selectors/userSelectors/getMyConnectedMembersCount";
import HoverWidget from "../UI/HoverWidget";
class ConnectedMembers extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      getConnectedMembers,
      connectedNotificationCount,
      markAsRead
    } = this.props;
    updateHeader({
      title: "Connected Members",
      description: "Members you are connected with"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Connected Members", link: "/connected-members" }
    ]);
    getConnectedMembers();
    if (connectedNotificationCount > 0) {
      markAsRead();
    }
  }
  componentWillUnmount() {
    const { clearMembers, clearConnectedMembers } = this.props;
    clearMembers();
    clearConnectedMembers();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members you are connected to"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.profileId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getConnectedMembers(state),
  lastResult: getMatchesLastResult(state),
  connectedNotificationCount: getMyConnectedMembersCount(state)
});

const mapDispatchToProps = dispatch => ({
  getConnectedMembers: () => dispatch(matchesActions.getConnectedMembers()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearConnectedMembers: () => dispatch(matchesActions.clearConnectedMembers()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, { type: matchesConstants.GET_CONNECTED_MEMBERS })
      )
    ),
  markAsRead: () => dispatch(matchesActions.markAllConnectedMembersAsRead())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedMembers);



// WEBPACK FOOTER //
// ./src/_components/ConnectedMembers/index.js